(function ($) {
  'use strict';

  /**
   * Main functionality should be in an 'init' function
   */
  var initStickyHeader = function () {
    var self = this;
    var scrollUp = 'scroll-up';
    var scrollDown = 'scroll-down';
    var lastScroll = 0;
    var desktop = window.matchMedia('(min-width: 1024px)');
    var responsive = window.matchMedia('(max-width: 1023px)');
    var $body = $('body');

    window.addEventListener('scroll', function (e) {
      var currentScroll = window.pageYOffset;
      if (currentScroll === 0) {
        self.classList.remove(scrollUp);
        return;
      }
      if (desktop.matches && currentScroll <= 150 || responsive.matches && currentScroll <= 60) {
        self.classList.remove(scrollDown);
        self.classList.remove(scrollUp);
      }
      else if (currentScroll > lastScroll && !self.classList.contains(scrollDown) && !$('html').hasClass('main-menu-open')) {
        // down
        self.classList.remove(scrollUp);
        self.classList.add(scrollDown);
      }
      else if (currentScroll < lastScroll && self.classList.contains(scrollDown)) {
        // up
        self.classList.remove(scrollDown);
        self.classList.add(scrollUp);
        $body.removeClass('transparent-header');
      }
      lastScroll = currentScroll;
    });
  };

  /**
   * This is boilerplate: add a behavior to window.DP.behaviors
   */
  window.DP.behaviors.stickyHeader = {
    attach: function (context) {
      $(context).find('body:not(.chaptered-page) .cc--header').once('stickyHeader').each(function () {
        initStickyHeader.apply(this);
      });
    }
  };

}(jQuery));

